import React from 'react';
import { SplitTreatments } from '@splitsoftware/splitio-react';

const isServer = typeof window === 'undefined';

const ClientWithSplitTreatments = (names, attributes) => function clientWithSplitTreatmentsHoc(WrappedComponent) {
  return isServer ? props => <WrappedComponent {...props} /> :
    props => (
      <SplitTreatments
        names={names}
        attributes={attributes} >
        {splitProps => (
          <WrappedComponent
            {...props}
            {...splitProps} />
        )}
      </SplitTreatments>
    );
};

export default ClientWithSplitTreatments;



// WEBPACK FOOTER //
// ./spa/Components/SplitIo/ClientWithSplitTreatments.jsx